import { Discount } from './Discount';
import { Image } from './Image';
import { Like } from './Like';
import { Price } from './Price';
import { ProductName } from './ProductName';
import { Review } from './Review';
import { StoreName } from './StoreName';
import { Tags } from './Tags';
import { Template } from './Template';
import { ZigzinExpress } from './ZigzinExpress';

export const ProductCard = {
  Template,
  Discount,
  Image,
  Price,
  ProductName,
  StoreName,
  Tags,
  Like,
  ZigzinExpress,
  Review,
};
